import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Shared loading indicator. Use anywhere the UI is waiting on a fetch/submit
 * (project rule: every async surface shows a loading state).
 */
export function Spinner({ className }: { className?: string }) {
  return (
    <Loader2
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin text-muted-foreground', className)}
    />
  );
}
